import React, { FC } from 'react';
import { DashboardCard } from '@monorepo/nova-ui';
import {
  ChartAreaSkeleton,
  ChartHeaderSkeleton,
  ChartLegendSkeleton,
} from './components';

export const PerformanceChartLoading: FC = () => {
  return (
    <DashboardCard
      sx={{
        flexDirection: 'column',
        alignItems: 'flex-end',
        minHeight: 400, // Ensure consistent height
      }}
    >
      <ChartHeaderSkeleton />
      <ChartAreaSkeleton />
      <ChartLegendSkeleton />
    </DashboardCard>
  );
};
